import Vue from 'vue'
import Multiselect from 'vue-multiselect'

Vue.component('multiselect', Multiselect)

import 'vue-multiselect/dist/vue-multiselect.min.css'
